import React, { useState, useEffect } from 'react'
import {
  EthereumProvider,
  EthereumNetwork,
  EthereumProviderNotFound,
  EthereumProviderNotConnected
} from '@manifoldxyz/manifold-sdk'
import Web3 from 'web3'

import {
  Button,
  // @ts-ignore
} from 'atomize';

export const JWT_CREATED = 'm-jwt-created'
export const JWT_COOKIE = 'manifoldJWT'

export const ETHEREUM_NETWORK_COLORS = {
  '1': '#59B3AE',
  '3': '#EC5A8C',
  '4': '#EFC45B',
  '42': '#886BF6',
  '6284': '#4D99EB'
}

export const SimpleConnect = (props: any) => {
  const [wrongChain, setWrongChain] = useState(false)
  const [walletConnected, setWalletConnected] = useState(false)
  const [, setChainInfo] = useState()
  const [badConfiguration, setBadConfiguration] = useState('')
  const [, setProviderAvailable] = useState(false)
  const [walletAddressFull, setWalletAddressFull] = useState('')
  const [walletENS, setWalletENS] = useState('')
  const [walletAddressShort, setWalletAddressShort] = useState('')
  const [automaticallyReconnect, ] = useState(false)
  const [, setWalletBalance] = useState()
  const [, setJWT] = useState('')
  const [network, ] = useState('')
  const [fallbackProvider, ] = useState()

  useEffect(() => {

    const wrapper = async () => {
      let address = EthereumProvider.selectedAddress()
      let ens = EthereumProvider.selectedENSName()
      await setWrongChainValue(setChainInfo, setWrongChain, setBadConfiguration, setProviderAvailable)

      // @ts-ignore
      await window.ethereum?.enable()
      if (address) {
        setProviderAvailable(true)
        setWalletAddressFull(address)
        props.setAccount(address)
        setWalletENS(ens || '')
        let addressLength = address.length
        let retval = address.slice(0, 6) + '...' + address.slice(addressLength - 4, addressLength)
        setWalletAddressShort(retval)
        setWalletConnected(true)
        localStorage.setItem('connectedAddress', EthereumProvider.selectedAddress() || '')
  
        await _automaticallyReconnect(automaticallyReconnect)
        await setWrongChainValue(setChainInfo, setWrongChain, setBadConfiguration, setProviderAvailable)
        updateBalance(walletAddressFull, setWalletBalance)
      }

      window.addEventListener(EthereumProvider.PROVIDER_CANT_CONNECT, () => {
        console.log(EthereumProvider.PROVIDER_CANT_CONNECT)
        // Need to check chainIsCorrect due to race conditions 
        // (i.e. this event firing before a successful chain switch, but received after a successful switch)
        if (!EthereumProvider.chainIsCorrect()) {
          setBadConfiguration('Wrong Network')
          setProviderAvailable(false)
        }
      })

      window.addEventListener(EthereumProvider.PROVIDER_NOT_FOUND, () => {
        console.log(EthereumProvider.PROVIDER_NOT_FOUND)

        // Need to check if there is still an issue with no provider being available
        // since it may be fired before a provider is set, but received after a new one is set
        try {
          // We can check if there is a provider by attempting to get a Web3 instance
          EthereumProvider.web3()
        } catch (error) {
          setBadConfiguration('No Network')
          setProviderAvailable(false)
        }
      })

      window.addEventListener(EthereumProvider.PROVIDER_CHANGED, async () => {
        console.log(EthereumProvider.PROVIDER_CANT_CONNECT)

        setBadConfiguration('')
        await setWrongChainValue(setChainInfo, setWrongChain, setBadConfiguration, setProviderAvailable)
        setProviderAvailable(true)
        await _automaticallyReconnect(automaticallyReconnect)
      })

      window.addEventListener(EthereumProvider.ADDRESS_CHANGED, async () => {
        console.log(EthereumProvider.ADDRESS_CHANGED)

        setBadConfiguration('')
        await setWrongChainValue(setChainInfo, setWrongChain, setBadConfiguration, setProviderAvailable)
        let address = EthereumProvider.selectedAddress()
        let ens = EthereumProvider.selectedENSName()
        if (address !== walletAddressFull || ens !== walletENS) {
          // Only change if address has changed
          setWalletAddressFull(address || '')
          props.setAccount(address || '')
          setWalletENS(ens || '')
  
          if (address) {
            let addressLength = address.length
            let retval = address.slice(0, 6) + '...' + address.slice(addressLength - 4, addressLength)
            setWalletAddressShort(retval)
            setWalletConnected(true)
            localStorage.setItem('connectedAddress', EthereumProvider.selectedAddress() || '')
          } else {
            setWalletAddressShort('')
            setWalletConnected(false)
            setJWT('')
            localStorage.removeItem('connectedAddress')
          }
        }
      })

      window.addEventListener(EthereumProvider.CHAIN_CHANGED, async () => {
        console.log(EthereumProvider.CHAIN_CHANGED)

        const networkLocal = await EthereumProvider.chainId()
        console.log(networkLocal)
        if (networkLocal !== 1) {
          props.setWrongNetworkModal(true)
        } else {
          props.setWrongNetworkModal(false)
        }

        setBadConfiguration('')
        await setWrongChainValue(setChainInfo, setWrongChain, setBadConfiguration, setProviderAvailable)
        updateBalance(walletAddressFull, setWalletBalance)
      })
  
      window.addEventListener(JWT_CREATED, (event) => {
        console.log(JWT_CREATED)

        // @ts-ignore
        setJWT(event.detail)
      })

      if (network === '' && fallbackProvider) {
        setBadConfiguration('Config Error')
        throw new Error('fallbackProvider should not be configured on network agnostic connections.')
      } else {
        try {
          // @ts-ignore
          await EthereumProvider.initialize(network, fallbackProvider)
        } catch (e) {
          if (e instanceof EthereumProviderNotFound) {
            setBadConfiguration('Wrong Network')
          } else if (e instanceof EthereumProviderNotConnected) {
            setBadConfiguration('Network Error')
          }
        }
        window.addEventListener('transactions-confirmed-event', () => {
          updateBalance(walletAddressFull, setWalletBalance)
        })
        await setWrongChainValue(setChainInfo, setWrongChain, setBadConfiguration, setProviderAvailable)
        await _automaticallyReconnect(automaticallyReconnect)
      }

    }

    wrapper()
  // eslint-disable-next-line
  }, [])

  return (
    <Button onClick={connect} className={props?.className} bg="medium">
      { walletConnected && walletENS ? `${walletENS}` : `${walletAddressShort}` }
      { wrongChain && 'Wrong Network' }
      { !walletConnected && 'Connect' }
      { badConfiguration && `${badConfiguration}` }
    </Button>
  )
}

const updateBalance = (walletAddressFull: string, setWalletBalance: Function) => {
  if (walletAddressFull) {
    // @ts-ignore
    window.ethereum.request({
      method: 'eth_getBalance',
      params: [
        walletAddressFull,
        'latest'
      ]
    })
      .then((res: any) => {
        setWalletBalance(parseFloat(Web3.utils.fromWei(res)).toFixed(2))
      })
  } else {
    setWalletBalance(undefined)
  }
}

const connect = async (event: any, isAutomaticallyConnecting = false) => {
  try {
    await EthereumProvider.connect()
  } catch (e) {
    console.warn(e)
    if (!isAutomaticallyConnecting) {
      alert('Could not connect to MetaMask, please try refreshing your page. If you continue to have issues, try closing your browser and re-opening it.')
    }
  }
}

const _automaticallyReconnect = async (automaticallyReconnect: boolean) => {
  if (automaticallyReconnect) {
    if (localStorage.getItem('connectedAddress')) {
      connect(null, true)
    }
  }
}

const setWrongChainValue = async (setChainInfo: Function, setWrongChain: Function, setBadConfiguration: Function, setProviderAvailable: Function) => {
  /* NOTE possibility that there is duplicate functionality here
   * between this method and badConfiguration variable.
   */
  try {
    let chainId = await EthereumProvider.chainId()
    if (chainId) {
      setChainInfo({
        name: EthereumNetwork[chainId],
        // @ts-ignore
        color: ETHEREUM_NETWORK_COLORS[chainId]
      })
      if (EthereumProvider.chainIsCorrect()) {
        setWrongChain(false)
      } else {
        setWrongChain(true)
      }
    }
  } catch (e) {
    // No network provider or valid provider for specified network.
    // See if reason is due to browser chain being on the wrong network
    if (!EthereumProvider.chainIsCorrect()) {
      setBadConfiguration('Wrong Network')
      setProviderAvailable(false)
    }
  }
}